if(!customElements.get('complete-the-look-form')) {
  class CompleteTheLookForm extends HTMLElement {
    constructor() {
      super();
      this.bindOnSubmit = this.onSubmit.bind(this);
      this.bindOnChange = this.onChange.bind(this);
      this.bindTriggerNotifyModal = this.triggerNotifyModal.bind(this);
      this.boundResizeSelect = this.resizeSelect.bind(this);
    }

    connectedCallback() {
      this.formContainer = this.querySelector('[data-type="add-to-cart-form"]');
      this.card = this.closest('.complete-the-look__card');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('.complete-the-look__product__submit');
      this.select = this.querySelector('.select__select');
      this.submitButtonText = this.submitButton?.querySelector('span') || this.submitButton?.querySelector('.product-form__submit-text') || null;
      this.notifyButton = this.querySelector('.complete-the-look__product__notify');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      if (this.submitButton) this.submitButton.addEventListener('click', this.bindOnSubmit);
      if (this.formContainer) this.formContainer.addEventListener('change', this.bindOnChange);
      if (this.notifyButton) this.notifyButton.addEventListener('click', this.bindTriggerNotifyModal);

      if (this.select) {
        this.resizeSelect();
        this.select.addEventListener('change', this.boundResizeSelect);
      }
    }

    disconnectedCallback() {
      if (this.submitButton) this.submitButton.removeEventListener('click', this.bindOnSubmit);
      if (this.formContainer) this.formContainer.removeEventListener('change', this.bindOnChange);
      if (this.notifyButton) this.notifyButton.removeEventListener('click', this.bindTriggerNotifyModal);
      if (this.select) this.select.removeEventListener('change', this.boundResizeSelect);
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      this.formContainer.querySelectorAll('select[name], input[name]').forEach((field) => {
        if (field.disabled) return;
        formData.append(field.name, field.value);
      });
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
        });
    }

    onChange(event) {
      const selectedOption = event.target?.querySelector('option:checked');
      if (!selectedOption) return;

      this.setDisabled(true);
      const href = selectedOption.dataset.variantUrl || '';
      const optionUrl = href.startsWith('/') ? window.location.origin + href : href;

      fetch(optionUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const guide = html.querySelector('.complete-the-look--guide');
          if (!guide || !this.card) return;

          const targetImage = this.card.querySelector('.complete-the-look__card__image');
          const targetHeader = this.card.querySelector('.complete-the-look__product__header');
          const targetPrice = this.card.querySelector('.complete-the-look__product__price');
          const targetAction = this.card.querySelector('.complete-the-look__product__action');
          const targetJson = this.card.querySelector('.complete-the-look__restock-json');

          const sourceImage = guide.querySelector('.complete-the-look__card__image');
          const sourceHeader = guide.querySelector('.complete-the-look__product__header');
          const sourcePrice = guide.querySelector('.complete-the-look__product__price');
          const sourceAction = guide.querySelector('.complete-the-look__product__action');
          const sourceJson = guide.querySelector('.complete-the-look__restock-json');

          if (targetImage && sourceImage) targetImage.replaceWith(sourceImage);
          if (targetHeader && sourceHeader) targetHeader.replaceWith(sourceHeader);
          if (targetPrice && sourcePrice) targetPrice.replaceWith(sourcePrice);
          if (targetAction && sourceAction)
            targetAction.classList.toggle('unavailable', sourceAction.classList.contains('unavailable'));
          if (targetJson && sourceJson) targetJson.replaceWith(sourceJson);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.setDisabled(false);
        });
    }

    setDisabled(disable) {
      if(disable == true) {
        this.card.setAttribute('disabled', true);
        this.card.setAttribute('aria-disabled', true);
        this.card.classList.add('disabled');
        this.select.setAttribute('disabled', true);
        this.select.setAttribute('aria-disabled', true);
        this.select.classList.add('disabled');
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('disabled');
      } else {
        this.card.removeAttribute('disabled');
        this.card.removeAttribute('aria-disabled');
        this.card.classList.remove('disabled');
        this.select.removeAttribute('disabled');
        this.select.removeAttribute('aria-disabled');
        this.select.classList.remove('disabled');
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('disabled');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    resizeSelect() {
      if (!this.select) return;
      const computed = getComputedStyle(this.select);
      const temp = document.createElement('span');
      temp.style.position = 'absolute';
      temp.style.visibility = 'hidden';
      temp.style.whiteSpace = 'pre';
      temp.style.fontSize = computed.fontSize;
      temp.style.fontFamily = computed.fontFamily;
      temp.style.fontWeight = computed.fontWeight;
      temp.textContent = this.select.options[this.select.selectedIndex]?.text || '';
      document.body.appendChild(temp);

      const buffer = 10;
      this.select.style.width = `${temp.offsetWidth + buffer}px`;
      document.body.removeChild(temp);
    }

    triggerNotifyModal() {
      this.restockJson = this.querySelector('.complete-the-look__restock-json');
      if (this.restockJson) this.restockProductInfo = JSON.parse(this.restockJson.textContent);
      window._RestockRocket.openModal(this.restockProductInfo, +this.variantIdInput.value);
    }

    get variantIdInput() {
      return this.querySelector('[name=id]');
    }
  }

  customElements.define('complete-the-look-form', CompleteTheLookForm)
 }